<ng-container *ngFor="let renewalType of this.renewalTypes$ | async">
  <ng-container *ngIf="renewalType.value === 'auto'">
    <em class="ds-icon ds-icon--replay" data-cy="renewal-icon"></em>
    <span class="ms-1" data-cy="renewal-text">{{ 'configurator.date.renewal' | cxTranslate }}</span>
    <ds-tooltip
      data-cy="renewal-tooltip"
      [ariaLabel]="'configurator.date.renewalTooltip' | cxTranslate"
      [content]="'configurator.date.renewalTooltip' | cxTranslate"
      class="ds-tooltip"
    ></ds-tooltip>
  </ng-container>
</ng-container>
